import { LinkProps } from '@mui/material';

import { StyledLink } from './styles';

export type TLink = LinkProps;

export const Link = ({
  underline = 'always',
  variant = 'body2',
  ...otherProps
}: TLink) => {
  return <StyledLink underline={underline} variant={variant} {...otherProps} />;
};
